module.exports = __webpack_public_path__ + "img/uni_auckland.3aa77346.jpg";